var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScienceSubsec1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2726_45546)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 59,
    r: 35,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.125 40.3125C52.9636 40.3125 50.375 42.9011 50.375 46.0625C50.375 48.7241 52.2224 50.959 54.6875 51.6047V57.7703C52.2224 58.416 50.375 60.6509 50.375 63.3125C50.375 63.6326 50.4199 63.947 50.4705 64.2559L46.2983 66.1033C45.5122 65.2778 44.4116 64.75 43.1875 64.75C40.8235 64.75 38.875 66.6985 38.875 69.0625C38.875 71.4265 40.8235 73.375 43.1875 73.375C45.5515 73.375 47.5 71.4265 47.5 69.0625C47.5 68.9502 47.4775 68.8435 47.4663 68.7312L51.6553 66.8726C52.7109 68.1921 54.3169 69.0625 56.125 69.0625C57.8433 69.0625 59.3762 68.282 60.4319 67.0691L67.7598 70.7358C67.6755 71.1233 67.625 71.5276 67.625 71.9375C67.625 75.0989 70.2136 77.6875 73.375 77.6875C76.5364 77.6875 79.125 75.0989 79.125 71.9375C79.125 68.7761 76.5364 66.1875 73.375 66.1875C71.6567 66.1875 70.1238 66.968 69.0681 68.1809L61.7402 64.5198C61.8245 64.1267 61.875 63.728 61.875 63.3125C61.875 60.6509 60.0276 58.416 57.5625 57.7703V51.6047C60.0276 50.959 61.875 48.7241 61.875 46.0625C61.875 42.9011 59.2864 40.3125 56.125 40.3125Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2726_45546",
    x: 0,
    y: 0,
    width: 118,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2726_45546"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2726_45546",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScienceSubsec1);
export default __webpack_public_path__ + "static/media/science_subsec_1.fd085de6ef7152b2939b15911cac297f.svg";
export { ForwardRef as ReactComponent };